<template>
    <span>
        <carousel :per-page="1" :autoplay="true" :autoplayTimeout="5000" :hidden="loading"
                  :loop="true" paginationPosition="bottom-overlay" id="carousel">
            <slide v-for="(element, index) in elements" v-bind:key="element.id" :title="'slajd '+(index+1)"
                   :class="carouselElementClass"
                   :style="'background-image: url(\''+element.img+'\');'"
            >
                <div class="carousel-body">
                    <div class="carousel-text px-3" v-if="element.header || element.description || element.footer">
                        <h4><strong>{{element.header}}</strong></h4>
                        <p style="font-size: large" class="text-justify m-0 p-0" v-html="element.description">{{element.description}}</p>
                        <p class="text-right m-0 p-0"><strong>{{element.footer}}</strong></p>
                    </div>
                    <a v-if="element.button" :href="element.url" target="_blank">
                        <button class="btn btn-primary pull-right mt-2">{{element.button}}</button>
                    </a>
                </div>
            </slide>
        </carousel>
        <loading :active.sync="loading"
                 :can-cancel="true"
                 :is-full-page="false">
        </loading>
    </span>
</template>

<script>
    import {Carousel, Slide} from 'vue-carousel';
    import Loading from 'vue-loading-overlay';

    export default {
        name: 'login-carousel',
        components: {Carousel, Slide, Loading},
        props: ['elements', 'carousel_element_view'],
        data () {
            return {
                loading: false,
                carouselElementClass: 'carousel-element-' + this.carousel_element_view
            }
        },
        created() {
            const self = this;
            $(document).ready(function () {
                self.loading = true;
                if (document.readyState === "complete") {
                    self.loading = false;
                }
            });

            $(window).on('load', function () {
                self.loading = false;
            });
        }
    }
</script>
